import * as firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyAXCeEb9PFjEhYslUFDUpg4-3nsSt4EMd8",
  authDomain: "beach-crew-1586306439491.firebaseapp.com",
  databaseURL: "https://beach-crew-1586306439491.firebaseio.com",
  projectId: "beach-crew-1586306439491",
  storageBucket: "beach-crew-1586306439491.appspot.com",
  messagingSenderId: "492444350573",
  appId: "1:492444350573:web:4fcf258cb90d05b4132764"
}

const firebaseApp = firebase.initializeApp(firebaseConfig);

export const db = firebaseApp.firestore();
